import { QueryClient } from '@tanstack/react-query';

import { useNonBenefitPriceTotalSummaryQuery } from '@/hooks/nonBenefit/nonBenefit.gql.impl';
import { NonBenefitPriceSummary } from '@/models/nonBenefit';
import { parseNonBenefitPriceTotalSummary } from '@/parsers/nonBenefit';

const useNonBenefitPriceTotalSummary = (
  treatmentMedicineId: string,
  regionCode: string,
) => {
  const {
    data: nonBenefitPriceTotalSummary = new NonBenefitPriceSummary({
      regionSummaries: [],
      nationalSummaries: [],
    }),
  } = useNonBenefitPriceTotalSummaryQuery(
    {
      regionCode,
      treatmentMedicineId,
    },
    {
      select: parseNonBenefitPriceTotalSummary,
    },
  );

  return {
    nonBenefitPriceTotalSummary,
  };
};

export default useNonBenefitPriceTotalSummary;

const prefetchQuery = async (
  queryClient: QueryClient,
  treatmentMedicineId: string,
  regionCode: string,
) => {
  await queryClient.prefetchQuery(
    useNonBenefitPriceTotalSummaryQuery.getKey({
      regionCode,
      treatmentMedicineId,
    }),
    useNonBenefitPriceTotalSummaryQuery.fetcher({
      regionCode,
      treatmentMedicineId,
    }),
  );
};

useNonBenefitPriceTotalSummary.prefetchQuery = prefetchQuery;
